import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar } from 'lucide-react';
export function ScheduleBanner() {
  return <section className="py-8 px-4 bg-[#0f1f3d]" data-id="element-355">
      <div className="max-w-4xl mx-auto" data-id="element-356">
        <Link to="/schedule" className="flex items-center justify-center gap-3 p-6 bg-white/10 backdrop-blur-sm rounded-xl border-2 border-[#a3d977]/40 hover:border-[#a3d977] hover:bg-white/15 transition-all group" data-id="element-357">
          <Calendar className="w-6 h-6 text-[#a3d977] group-hover:scale-110 transition-transform" data-id="element-358" />
          <div className="text-center" data-id="element-359">
            <div className="text-white font-bold text-lg" data-id="element-360">
              View Our Class Schedule
            </div>
            <div className="text-gray-300 text-sm" data-id="element-361">
              Find the perfect class time for you
            </div>
          </div>
        </Link>
      </div>
    </section>;
}